import { Component } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { HeaderComponent } from '../../layout/components/header/header.component'
import { AppGridComponent } from '../../widgets/app-grid/app-grid.component'
import { AppDescriptionWidget, AppGridWidget, AppLogoWidget, AppNameWidget, ProjectCMSWidgetType } from 'htv-lib'
import { AppNameComponent } from '../../widgets/app-name/app-name.component'
import { AppLogoComponent } from '../../widgets/app-logo/app-logo.component'
import { AppDescriptionComponent } from '../../widgets/app-description/app-description.component'

@Component({
  selector: 'app-apps',
  standalone: true,
  imports: [
    TranslateModule,
    AppGridComponent,
    HeaderComponent,
    AppNameComponent,
    AppLogoComponent,
    AppDescriptionComponent,
  ],
  templateUrl: './apps.component.html',
  styleUrls: ['./apps.component.scss'],
})
export class AppsComponent {
  config: AppGridWidget = {
    type: ProjectCMSWidgetType.APP_GRID,
    name: 'DefaultAppGrid',
    width: 1440,
    height: 920,
    x: 480,
    y: 160,
  }
  applogoconfig: AppLogoWidget = {
    type: ProjectCMSWidgetType.APP_LOGO,
    name: 'DefaultAppLogo',
    width: 400,
    height: 270,
    x: 40,
    y: 160,
    objectFit: 'contain',
    alignment: 'center',
  }
  appnameconfig: AppNameWidget = {
    type: ProjectCMSWidgetType.APP_NAME,
    name: 'DefaultAppName',
    width: 400,
    height: 100,
    x: 40,
    y: 430,
    color: 'white',
    fontSize: 36,
    alignment: 'left',
  }
  appdescriptionconfig: AppDescriptionWidget = {
    type: ProjectCMSWidgetType.APP_DESCRIPTION,
    name: 'DefaultAppName',
    width: 400,
    height: 510,
    x: 40,
    y: 530,
    color: 'white',
    fontSize: 24,
    alignment: 'left',
  }
}
